module.exports = __webpack_public_path__ + "img/ocean-room-5.d77f476e.jpg";